"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClasses = void 0;
var focusClass = "\n        focus:squid-ring-0\n        focus:squid-ring-offset-0\n        focus-visible:squid-ring-0\n        focus-visible:squid-ring-offset-0\n  ";
var checkedClass = "\n        focus:checked:squid-bg-alias-color-bg-primary\n        checked:squid-bg-alias-color-bg-primary\n        checked:squid-border-alias-color-border-active\n        checked:squid-ring-0\n        checked:squid-ring-offset-0\n";
var indeterminateClass = "\n        indeterminate:squid-bg-alias-color-bg-primary \n        indeterminate:squid-border-alias-color-border-active\n        indeterminate:squid-ring-0\n        indeterminate:squid-ring-offset-0\n        hover:indeterminate:squid-bg-alias-color-bg-primary \n        focus:indeterminate:squid-bg-alias-color-bg-primary\n";
var hoverClass = "\n        hover:checked:squid-bg-alias-color-bg-primary\n        hover:checked:squid-border-alias-color-border-active\n        hover:squid-bg-alias-state-base-hover\n        hover:squid-border-alias-color-border-base\n        hover:squid-shadow-core-shadow-border-hover-color\n        hover:squid-ring-0\n        hover:squid-ring-offset-0\n        ";
var checkboxClass = 'squid-rounded-component-checkbox-border-radius';
var radioClass = 'squid-rounded-component-radio-border-radius';
var disabledClass = "\n  squid-bg-alias-color-bg-disabled\n  squid-border-core-color-neutral-white\n  checked:squid-bg-alias-color-bg-disabled\n  checked:squid-border-core-color-neutral-white\n  hover:squid-bg-alias-color-bg-disabled\n  hover:squid-border-core-color-neutral-white\n  hover:checked:squid-bg-alias-color-bg-disabled\n  hover:checked:squid-border-core-color-neutral-white\n";
var getClasses = function (type, disabled, hover, isCheckbox) {
    var classes = [];
    classes.push(type === 'checkbox' ? checkboxClass : radioClass);
    if (disabled) {
        classes.push(disabledClass);
    }
    else {
        classes.push(checkedClass, focusClass);
        if (isCheckbox) {
            classes.push(indeterminateClass);
        }
        if (hover) {
            classes.push(hoverClass);
        }
    }
    return classes;
};
exports.getClasses = getClasses;
